var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdSerIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2938_1099)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2938_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4727 40.7695C36.8693 40.7695 35.494 41.7606 34.9248 43.1621H31.582V46.0332H34.9248C35.494 47.4347 36.8693 48.4258 38.4727 48.4258C40.5835 48.4258 42.3008 46.7085 42.3008 44.5977C42.3008 42.4868 40.5835 40.7695 38.4727 40.7695Z",
    fill: "#B2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1719 32.6348C44.5426 32.6348 43.949 32.7883 43.4247 33.0584L39.8702 30.0963C39.6122 29.8814 39.287 29.7637 38.9512 29.7637H31.582V32.6348H38.4314L41.548 35.232C41.4163 35.6185 41.3438 36.0322 41.3438 36.4629C41.3438 38.5737 43.061 40.291 45.1719 40.291C47.2827 40.291 49 38.5737 49 36.4629C49 34.3521 47.2827 32.6348 45.1719 32.6348Z",
    fill: "#B2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1719 20.6719C43.5686 20.6719 42.1932 21.663 41.6241 23.0645H31.582V25.9355H41.6241C42.1932 27.337 43.5686 28.3281 45.1719 28.3281C47.2827 28.3281 49 26.6108 49 24.5C49 22.3892 47.2827 20.6719 45.1719 20.6719Z",
    fill: "#B2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8702 18.9036L43.4247 15.9415C43.949 16.2117 44.5426 16.3652 45.1719 16.3652C47.2827 16.3652 49 14.6479 49 12.5371C49 10.4263 47.2827 8.70898 45.1719 8.70898C43.061 8.70898 41.3438 10.4263 41.3438 12.5371C41.3438 12.9678 41.4163 13.3815 41.548 13.768L38.4314 16.3652H31.582V19.2363H38.9512C39.287 19.2363 39.6122 19.1186 39.8702 18.9036Z",
    fill: "#B2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4727 8.23047C40.5835 8.23047 42.3008 6.51317 42.3008 4.40234C42.3008 2.29152 40.5835 0.574219 38.4727 0.574219C36.8693 0.574219 35.494 1.56532 34.9248 2.9668H31.582V5.83789H34.9248C35.494 7.23937 36.8693 8.23047 38.4727 8.23047Z",
    fill: "#B2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3555 24.5C14.3555 30.0409 18.8634 34.5488 24.4043 34.5488C25.9446 34.5488 27.4049 34.2 28.7109 33.5779V15.4221C27.4049 14.8 25.9446 14.4512 24.4043 14.4512C18.8634 14.4512 14.3555 18.9591 14.3555 24.5Z",
    fill: "#B2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2754 0.0957031H21.5332C20.7404 0.0957031 20.0977 0.738445 20.0977 1.53125V3.39985C17.4039 3.94862 14.826 5.01657 12.5298 6.53499L11.2082 5.21343C10.6475 4.6528 9.73865 4.6528 9.17803 5.21343L5.11772 9.27373C4.5571 9.83426 4.5571 10.7432 5.11772 11.3039L6.43929 12.6255C4.92086 14.9217 3.85291 17.4996 3.30415 20.1934H1.43555C0.642742 20.1934 0 20.8361 0 21.6289V27.3711C0 28.1639 0.642742 28.8066 1.43555 28.8066H3.30415C3.85291 31.5004 4.92086 34.0783 6.43929 36.3746L5.11763 37.6962C4.84842 37.9654 4.69721 38.3305 4.69721 38.7112C4.69721 39.092 4.84842 39.457 5.11763 39.7262L9.17803 43.7866C9.73865 44.3472 10.6475 44.3472 11.2082 43.7866L12.5298 42.465C14.826 43.9834 17.4039 45.0513 20.0977 45.6001V47.4688C20.0977 48.2616 20.7404 48.9043 21.5332 48.9043H27.2754C28.0682 48.9043 28.7109 48.2616 28.7109 47.4688V36.6809C27.3632 37.1588 25.9138 37.4199 24.4043 37.4199C17.2803 37.4199 11.4844 31.624 11.4844 24.5C11.4844 17.376 17.2803 11.5801 24.4043 11.5801C25.9138 11.5801 27.3632 11.8412 28.7109 12.3191V1.53125C28.7109 0.738445 28.0682 0.0957031 27.2754 0.0957031Z",
    fill: "#3EB3FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2938_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2938_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdSerIcon08);
export default __webpack_public_path__ + "static/media/cd-ser_icon08.bdcbdead81b95ee3f6e4fddf90e632e9.svg";
export { ForwardRef as ReactComponent };